export default {
  updateRowIdInUrl(rowId) {
    let url = window.location.pathname + window.location.search;

    url = url.replace(/rows\/([A-Z]|[0-9]|[a-z])\w+/g, `rows/${rowId}`);

    window.history.replaceState({}, rowId, url);
  },

  updateQueryInUrl(field, value) {
    let url = window.location.pathname + window.location.search;

    url = url.replace(
      new RegExp(`${field}=([A-Z]|[0-9]|[a-z])*`, 'g'),
      `${field}=${value}`,
    );

    window.history.replaceState({}, value, url);
  },
};
